module.exports = __webpack_public_path__ + "img/rank-3rd.6e67f5a2.png";